import { l as matchesBreakpoint, u as scrollAnimationsDisabled } from "@theme/utils";
import { t as gsapWithCSS } from "@theme/gsap";
//#region frontend/islands/in-view.js
var ORDERED_BREAKPOINTS = [
	"2xl",
	"xl",
	"lg",
	"md",
	"sm"
];
function resolveResponsiveAttr(dataset, attr) {
	for (const bp of ORDERED_BREAKPOINTS) {
		const key = attr + bp.charAt(0).toUpperCase() + bp.slice(1);
		if (dataset[key] !== void 0 && matchesBreakpoint(bp)) return dataset[key];
	}
	return dataset[attr];
}
var PRESETS = {
	fade: { opacity: 0 },
	"fade-up": {
		opacity: 0,
		y: 5
	},
	"fade-down": {
		opacity: 0,
		y: -5
	},
	"fade-right": {
		opacity: 0,
		x: -5
	},
	"fade-left": {
		opacity: 0,
		x: 5
	}
};
var InView = class extends window.HTMLElement {
	connectedCallback() {
		const firstChild = this.querySelector(":scope > :not(style):not(script)");
		if (!firstChild) return;
		this._viewObserver = new IntersectionObserver((entries) => {
			if (!entries[0].isIntersecting) return;
			this._viewObserver.disconnect();
			this._viewObserver = null;
			this._init();
		}, { rootMargin: "300px 0px" });
		this._viewObserver.observe(firstChild);
	}
	_init() {
		if (!this.isConnected) return;
		const animation = resolveResponsiveAttr(this.dataset, "animation");
		const selector = this.dataset.targets ?? ":scope > *";
		const targets = [...this.querySelectorAll(selector)];
		if (!targets.length) return;
		if (!matchesBreakpoint(this.dataset.breakpoint)) {
			gsapWithCSS.set(targets, {
				opacity: 1,
				x: 0,
				y: 0,
				visibility: "visible"
			});
			return;
		}
		if (scrollAnimationsDisabled() || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
			gsapWithCSS.set(targets, {
				opacity: 1,
				x: 0,
				y: 0,
				visibility: "visible"
			});
			return;
		}
		if (this._played || this.closest(".swiper-slide-duplicate")) {
			gsapWithCSS.set(targets, {
				opacity: 1,
				x: 0,
				y: 0,
				visibility: "visible"
			});
			return;
		}
		if (animation && PRESETS[animation]) gsapWithCSS.set(targets, {
			...PRESETS[animation],
			visibility: "visible"
		});
		this._animObserver = new IntersectionObserver((entries) => {
			if (!entries[0].isIntersecting) return;
			this._animObserver.disconnect();
			this._animObserver = null;
			this._tween = gsapWithCSS.to(targets, {
				opacity: 1,
				x: 0,
				y: 0,
				visibility: "visible",
				duration: parseFloat(this.dataset.duration ?? "1.0"),
				delay: parseFloat(resolveResponsiveAttr(this.dataset, "delay") ?? "0"),
				stagger: { amount: parseFloat(this.dataset.stagger ?? "0") },
				ease: this.dataset.ease ?? "power3.out",
				onComplete: () => {
					this._played = true;
				}
			});
		}, { rootMargin: "0px 0px -5% 0px" });
		this._animObserver.observe(targets[0]);
	}
	disconnectedCallback() {
		this._viewObserver?.disconnect();
		this._animObserver?.disconnect();
		this._tween?.kill();
	}
};
customElements.define("in-view", InView);
//#endregion
